import * as React from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { ActionModal } from '@sales-center/components'
import { BulkAddNoteFormWrapper } from './BulkAddNoteForm/BulkAddNoteFormWrapper'
import { ILead } from '@user/store/lead'
import { IOpportunity } from '@user/store/opportunity'

type Props = {
  open: boolean
  onClose: () => void
  entityType: ENTITY_TYPES
  data: ILead[] | IOpportunity[]
}

export function BulkAddNotesModel(props: Props) {
  const { onClose, open, data, entityType } = props
  return (
    <ActionModal title={'Add Note'} onClose={onClose} open={open}>
      <BulkAddNoteFormWrapper
        data={data}
        entityType={entityType}
        onClose={onClose}
      />
    </ActionModal>
  )
}
